"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextBoxProperties = void 0;
var margins_1 = require("@devexpress/utils/lib/geometry/margins");
var enums_1 = require("./enums");
var TextBoxProperties = (function () {
    function TextBoxProperties(contentMargins) {
        this.resizeShapeToFitText = true;
        this.upright = false;
        this.verticalAlignment = enums_1.DrawingTextAnchoringType.Top;
        this.wrapText = true;
        this.leftMargin = 0;
        this.rightMargin = 0;
        this.topMargin = 0;
        this.bottomMargin = 0;
        if (contentMargins) {
            this.leftMargin = contentMargins.left;
            this.rightMargin = contentMargins.right;
            this.topMargin = contentMargins.top;
            this.bottomMargin = contentMargins.bottom;
        }
    }
    TextBoxProperties.prototype.clone = function () {
        var textBoxProperties = new TextBoxProperties();
        textBoxProperties.resizeShapeToFitText = this.resizeShapeToFitText;
        textBoxProperties.upright = this.upright;
        textBoxProperties.verticalAlignment = this.verticalAlignment;
        textBoxProperties.wrapText = this.wrapText;
        textBoxProperties.leftMargin = this.leftMargin;
        textBoxProperties.rightMargin = this.rightMargin;
        textBoxProperties.topMargin = this.topMargin;
        textBoxProperties.bottomMargin = this.bottomMargin;
        return textBoxProperties;
    };
    TextBoxProperties.prototype.equals = function (obj) {
        if (!obj)
            return false;
        return obj.resizeShapeToFitText === this.resizeShapeToFitText &&
            obj.upright === this.upright &&
            obj.verticalAlignment === this.verticalAlignment &&
            obj.wrapText === this.wrapText &&
            obj.leftMargin === this.leftMargin &&
            obj.rightMargin === this.rightMargin &&
            obj.topMargin === this.topMargin &&
            obj.bottomMargin === this.bottomMargin;
    };
    TextBoxProperties.prototype.getContentMargins = function () {
        return new margins_1.Margins(this.leftMargin, this.rightMargin, this.topMargin, this.bottomMargin);
    };
    TextBoxProperties.prototype.setMarginsToAnotherMeasuringSystem = function (converter) {
        this.leftMargin = converter(this.leftMargin);
        this.rightMargin = converter(this.rightMargin);
        this.topMargin = converter(this.topMargin);
        this.bottomMargin = converter(this.bottomMargin);
        return this;
    };
    return TextBoxProperties;
}());
exports.TextBoxProperties = TextBoxProperties;
